(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glitter-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-stk-glitter]').forEach(function (section) {
  var track = section.querySelector('[data-stk-track]');
  if (!track) return;
  var prev = section.querySelector('[data-stk-prev]');
  var next = section.querySelector('[data-stk-next]');
  function step(dir) {
    var card = track.querySelector('.stk-card');
    var amount = card ? card.getBoundingClientRect().width + 16 : 280;
    track.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siu-finish-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSpotlight(section) {
      if (section.dataset.fsReady) return;
      section.dataset.fsReady = '1';
      var track = section.querySelector('[data-fs-track]');
      function step(dir) {
        var card = track && track.querySelector('.fs__card');
        if (!card) return;
        track.scrollBy({ left: dir * (card.getBoundingClientRect().width + 18) * 2, behavior: 'smooth' });
      }
      var prev = section.querySelector('[data-fs-prev]');
      var next = section.querySelector('[data-fs-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      section.querySelectorAll('[data-fs-form]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          var actions = window.Shopify && window.Shopify.actions;
          if (!actions || !actions.updateCart) return; // fall back to the normal add-to-cart
          e.preventDefault();
          var btn = form.querySelector('.fs__add');
          var label = btn.querySelector('.fs__add-label');
          var id = form.querySelector('[name="id"]').value;
          btn.classList.add('is-loading');
          actions
            .updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }] }, { event: { context: 'standard-action' } })
            .then(function (res) {
              btn.classList.remove('is-loading');
              if (res && res.userErrors && res.userErrors.length) { label.textContent = 'Not available'; return; }
              btn.classList.add('is-added');
              setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
              if (actions.openCart) actions.openCart();
            })
            .catch(function () { btn.classList.remove('is-loading'); form.submit(); });
        });
      });
    }
    function initAll() { document.querySelectorAll('[data-fs]').forEach(initSpotlight); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-fs]');
      if (s) initSpotlight(s);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
